module.exports = __webpack_public_path__ + "img/45.d5aba529.png";